<h2 mat-dialog-title>
    {{'import_users_title' | translate}}
</h2>

<mat-dialog-content class="dialog-content-pad-10">
    <h3 class="media-heading"><small>{{ 'import_users_description' | translate }}.</small></h3>

      <div class="col-md-8 pt-2 mx-auto">

        <div class="media push mb-4 p-3">
          <div class="media-body">
            <h4 class="media-heading">{{'step_1' | translate}}</h4>
            <div class="row">
              <div class="col-md-8">
                <p>{{ 'download_template' | translate}}.<br>
                  {{ 'download_template_column_order' | translate}}.</p>
              </div>
              <div class="col-md-4">
                <a href="{{excel_template_url}}"
                   class="btn btn-primary d-block mt-2 mt-md-0"><i class="fa fa-file-excel-o"></i> {{'download_template_short'|translate}}</a>
              </div>
            </div>
          </div>
        </div>

        <div class="media push mb-4 p-3">
          <div class="media-body">
            <h4 class="media-heading">{{'step_2' | translate}}</h4>
            <div class="row">
              <div class="col-md-8">
                <p>{{ 'send_template_to' | translate}} <a
                        href="mailto:support@teammood.com?subject={{email_subject}}&body={{email_body}}">support&#64;teammood.com</a>.<br>
                  {{ 'we_ll_add_them' | translate}}.</p>
              </div>
              <div class="col-md-4">
                <a href="mailto:support@teammood.com?subject={{email_subject}}&body={{email_body}}"
                   class="btn btn-primary d-block mt-2 mt-md-0"><i class="fa fa-envelope-o"></i>
                  {{'send_file'|translate}}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
</mat-dialog-content>

<mat-dialog-actions class="justify-content-center">
    <button type="button"
            class="btn btn-default"
            (click)="close()">{{'close' | translate}}</button>
</mat-dialog-actions>
